import React from "react";
import { useSpring, animated } from '@react-spring/web';
import { useSelector } from "react-redux";
import { Cookies } from '../../index.js';
import { isLocalHost } from '../../shared/host_utils.js';

function App_store() {
    const latest_version = useSelector(state => state.latest_version);

    const getMainDomain = () => {
        const hostname = window.location.hostname;
        const parts = hostname.split('.');
        return parts.length > 2 ? parts[parts.length - 2] : parts[0];
    };

    const main_domain = !isLocalHost(window.location.hostname)
        ? (Cookies.get("main_domain") || getMainDomain() || "hust")
        : (Cookies.get("main_domain") || "hust");
    const show_hust_v2 = (latest_version == 2 || latest_version == 3) && main_domain == 'hust';

    const springProps = useSpring({
        to: async (next) => {
          while (true) {
            await next({
              transform: 'scale(1.2)',
              backgroundColor: 'rgba(255, 0, 0, 0.3)',
              boxShadow: '0px 5px 10px rgba(255, 0, 0, 0.3)'
            });
            await next({
              transform: 'scale(1)',
              backgroundColor: 'rgba(128, 0, 128, 0.3)',
              boxShadow: '0px 5px 10px rgba(255, 0, 255, 0.5)'
            });
          }
        },
        from: {
          transform: 'scale(1)',
          backgroundColor: 'rgba(128, 0, 128, 0.3)',
          boxShadow: '0px 5px 10px rgba(255, 0, 255, 0.5)'
        },
        config: { tension: 500, friction: 5 }
      });

    const storeButtons = (
        <>
            <div className="mt-0">
                <a href='https://play.google.com/store/apps/details?id=com.hm.hustmedia'>
                    <animated.button style={springProps}>

                        <div className="flex mt-1 my-1   w-60 h-14 bg-transparent text-black border border-black rounded-xl items-center justify-center">
                            <div className="mr-3">
                                <img src="https://cdn-icons-png.flaticon.com/512/732/732208.png" alt="App Store" className="w-8 h-8" />
                            </div>
                            <div>
                                <div className="text-xs">Get it on</div>
                                <div className="text-2xl font-semibold font-sans -mt-1">Google Play</div>
                            </div>
                        </div>
                    </animated.button>
                </a>

            </div>

            <br></br>
            <div className="mt-2">
                <a href='https://apps.apple.com/app/hust-media/id6444485454'>
                    <animated.button style={springProps}>

                        <div className="flex mt-1 my-1  w-60 h-14 bg-transparent text-black border border-black rounded-xl items-center justify-center">
                            <div className="mr-3">
                                <svg viewBox="0 0 384 512" width="30" >
                                    <path fill="currentColor" d="M318.7 268.7c-.2-36.7 16.4-64.4 50-84.8-18.8-26.9-47.2-41.7-84.7-44.6-35.5-2.8-74.3 20.7-88.5 20.7-15 0-49.4-19.7-76.4-19.7C63.3 141.2 4 184.8 4 273.5q0 39.3 14.4 81.2c12.8 36.7 59 126.7 107.2 125.2 25.2-.6 43-17.9 75.8-17.9 31.8 0 48.3 17.9 76.4 17.9 48.6-.7 90.4-82.5 102.6-119.3-65.2-30.7-61.7-90-61.7-91.9zm-56.6-164.2c27.3-32.4 24.8-61.9 24-72.5-24.1 1.4-52 16.4-67.9 34.9-17.5 19.8-27.8 44.3-25.6 71.9 26.1 2 49.9-11.4 69.5-34.3z" />
                                </svg>
                            </div>
                            <div>
                                <div className="text-xs">Download on the</div>
                                <div className="text-2xl font-semibold font-sans -mt-1">App Store</div>
                            </div>
                        </div>

                    </animated.button>   </a>    </div>
                    
            {!show_hust_v2 && (
                <>
                    <br></br>
                    <div className="mt-2">
                        <a href='https://tecom.pro/'>
                            <animated.button style={springProps}>
                                <div className="flex mt-1 my-1  w-60 h-14 bg-transparent text-black border border-black rounded-xl items-center justify-center">
                                    <div className="mr-3">
                                        <img src="https://cdn-icons-png.flaticon.com/512/220/220603.png" alt="App Store" className="w-8 h-8" />
                                    </div>
                                    <div>
                                        <div className="text-xs">Open on pc</div>
                                        <div className="text-xl font-semibold font-sans -mt-1">Single Page App </div>
                                    </div>
                                </div>
                            </animated.button>  </a>
                    </div>
                </>
            )}
        </>
    );
    
    return (
        <>
            {(show_hust_v2) ? (
                <>
                    {storeButtons}
                </>
            ) : (
                <>
                    {storeButtons}
                </>
            )}
        </>
    );
}

export default App_store;
